// packages
import cx from 'classnames';
import { Component, h } from 'preact';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import YourRaces from './components/YourRaces';
import Portal from './components/Portal';
import SeatPartyDivider from './components/SeatPartyDivider';

import { determineContestTitle } from './election-utils';
import { RESULTS_IN_USE } from './endpoints';
import getJSON from './utils/get-json';
import loadJsonScript from './utils/load-json-script';

type State = {
  data: { [key: string]: any };
  now: Date | null;
};

class App extends Component<{}, State> {
  _yourPortal: any;
  _usPortal: any;
  _supremePortal: any;
  _senatePortal: any;
  _housePortal: any;
  _sboePortal: any;

  constructor(props: {}) {
    super(props);

    this.state = {
      data: [],
      now: null,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    const now = new Date();
    getJSON(RESULTS_IN_USE).then(data => this.setState({ data, now }));
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {}

  componentDidUpdate() {}

  render() {
    const { data } = this.state;

    const seats_mapped = data.map((number: any) => ({
      office: number.office,
      office_slug: number.office_slug,
    }));

    function unique(array: any, propertyName: any) {
      return array.filter(
        (e: any, i: any) =>
          array.findIndex((a: any) => a[propertyName] === e[propertyName]) === i
      );
    }

    const unique_seats = unique(seats_mapped, 'office_slug');

    const notes: any[] = (loadJsonScript('notes_data') as any[]) || [];

    const renderCandidate = (candidate: any, idx: any, { totalVotes }: any) => (
      <CandidateRow
        key={candidate.id}
        ballotName={candidate.name}
        candidateId={candidate.id}
        contestIsCalled={false}
        isIncumbent={candidate.is_incumbent}
        isWinner={candidate.is_winner}
        party={candidate.party}
        totalVotesInContest={totalVotes}
        votes={candidate.votes}
      />
    );

    return (
      <div class="results">
        <Portal node={document.getElementById('lookup-select')} ref={(ref: any) => (this._yourPortal = ref)}>
          <YourRaces contests={data} />
        </Portal>

        <Portal node={document.querySelector('#us-senate .contests')} ref={(ref: any) => (this._usPortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'U.S. Senate').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}`)}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#attorney-general .contests')} ref={(ref: any) => (this._usPortal = ref)}>
          <div>
            <div class="office__contests seat__contests-double">
              {data.filter((contest: any) => contest.office === 'Attorney General').map((contest: any) => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                  tableHeader={CandidateRow.Header}
                  notes={notes.filter((item: any) => item.type === `${contest.office_slug}-${contest.party}`)}
                  renderCandidate={renderCandidate}
                />
              ))}
            </div>
            {notes.filter((item: any) => item.type === 'attorney-general').map((item: any) => (
              <p class="note__text note__text--full-width" dangerouslySetInnerHTML={{ __html: item.value }} />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#lieutenant-governor .contests')} ref={(ref: any) => (this._usPortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'Lieutenant Governor').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}`)}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#texas-court-of-criminal-appeals .contests')} ref={(ref: any) => (this._usPortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'Texas Court of Criminal Appeals').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}`)}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#railroad-commission-of-texas .contests')} ref={(ref: any) => (this._supremePortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'Texas Railroad Commission').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}` || item.type === 'railroad-commissioner')}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#us-house .contests')} ref={(ref: any) => (this._usPortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'U.S. House').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}`)}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#state-board-of-education .contests')} ref={(ref: any) => (this._sboePortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'State Board of Education').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}`)}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#texas-senate .contests')} ref={(ref: any) => (this._senatePortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'Texas Senate').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}`)}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>

        <Portal node={document.querySelector('#texas-house .contests')} ref={(ref: any) => (this._housePortal = ref)}>
          <div class="office__contests seat__contests-double">
            {data.filter((contest: any) => contest.office === 'Texas House').map((contest: any) => (
              <Contest
                key={contest.id}
                contest={contest}
                columnCount={CandidateRow.columnCount}
                contestTitle={determineContestTitle(data.filter((item: any) => item.office_slug === contest.office_slug)[0])}
                tableHeader={CandidateRow.Header}
                notes={notes.filter((item: any) => item.type === contest.office_slug || item.type === `${contest.office_slug}-${contest.party}`)}
                renderCandidate={renderCandidate}
              />
            ))}
          </div>
        </Portal>
      </div>
    );
  }
}

export default App;
